import { HANDLED_SUBCODES, } from 'app/domains/esigning/components/EsigningForm/types';
export const isFailedSubcodeHandled = (subcode) => subcode !== null &&
    subcode !== undefined &&
    HANDLED_SUBCODES.includes(subcode);
